(function () {
    'use strict';

    angular
        .module('app')
        .controller('UserListCtrl', UserListCtrl);

    UserListCtrl.$inject = [
        '$q',
        '$routeParams',
        'SystemService',
        'EntityTemplatesService',
        'DialogService',
        'ChilliUserProfileService',
        'WindowTitleService'];

    function UserListCtrl(
        $q,
        $routeParams,
        SystemService,
        EntityTemplatesService,
        DialogService,
        ChilliUserProfileService,
        WindowTitleService) {

        /* jshint validthis:true */
        var vm = this;
        vm.showPanel = showPanel;
        vm.loading = true;
        vm.permissionDenied = false;

        activate();

        function activate() {
            WindowTitleService.setTitle('Users');

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: loadEverything,
                onUserIsNotAdmin: function () { vm.permissionDenied = true; },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () { vm.loading = false; }
            });

            function loadEverything() {
                var loadPromises = [];
                loadPromises.push(loadListPageSize());
                loadPromises.push(loadEntityTemplate());

                return $q.all(loadPromises).then(function () {
                    var dashboardSettingConfiguration = { SearchFields: {} };
                    dashboardSettingConfiguration.ListPageSize = vm.ListPageSize;
                    dashboardSettingConfiguration.EntityTemplateId = vm.entityTemplateId;

                    if (!angular.isUndefined($routeParams.entityTemplateId) && $routeParams.entityTemplateId !== null) {
                        dashboardSettingConfiguration.EntityTemplateId = $routeParams.entityTemplateId;
                    }
                    vm.dashboardSettingConfiguration = angular.copy(dashboardSettingConfiguration);
                });
            }
        }

        function loadListPageSize() {
            return SystemService.getMenuListSize('Entities')
                .then(getListPageSizeOk, getListPageSizeError);

            function getListPageSizeOk(data) {
                vm.ListPageSize = data;
            }

            function getListPageSizeError(response) {
                DialogService.error('Error fetching list size', response);
            }
        }

        function loadEntityTemplate() {
            return EntityTemplatesService.query({
                EntityType: 'User'
            })
                .then(getEntityTemplatesOk, getEntityTemplatesError);

            function getEntityTemplatesOk(data) {
                if (data.TemplateCount > 0) {
                    vm.entityTemplateId = data.EntityTemplates[0].Id;
                }
                else {
                    DialogService.error('User Entity Template was not found');
                }
            }

            function getEntityTemplatesError(response) {
                DialogService.error('Error fetching User Entity Template', response);
            }
        }

        function showPanel() {
            return !_.isNil(vm.dashboardSettingConfiguration);
        }
    }
})();
